export const EyeIcon = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00013 6.45969C8.0683 6.45969 8.93434 5.58191 8.93434 4.49904C8.93434 3.41618 8.0683 2.53839 7.00013 2.53839C5.93187 2.53839 5.06593 3.41618 5.06593 4.49904C5.06593 5.58191 5.93187 6.45969 7.00013 6.45969Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.99972 0.578125C9.78304 0.578125 12.2002 2.16733 13.4163 4.49942C12.2002 6.83151 9.78304 8.42072 6.99972 8.42072C4.2163 8.42072 1.79913 6.83151 0.583008 4.49942C1.79913 2.16733 4.2163 0.578125 6.99972 0.578125ZM6.99972 7.44039C4.77548 7.44039 2.81971 6.26969 1.70155 4.49942C2.81971 2.72915 4.77548 1.55845 6.99972 1.55845C9.22386 1.55845 11.1796 2.72915 12.2978 4.49942C11.1796 6.26969 9.22386 7.44039 6.99972 7.44039Z"
      fill="#18A0FB"
    />
  </svg>
);
